"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgFireplace = function SvgFireplace(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    stroke: "#4D4D4D",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.534 18.644C8.216 18.038 8 17.4 8 16.606c0-1.387.437-2.125.846-2.642.408-.517.854-1.057.988-2.2.677.318 1.56.975 1.872 1.63-.106-.278-.343-.479-.497-.688-.61-.826.982-1.47.096-3.706 2.998.181 3.736 4.373 3.69 4.88-.061.686-.163.838-.47 1.291.683-.904.823-2.2.823-2.877.999.838 1.696 2.113 1.496 4.306-.221 2.416-1.785 3.906-4.218 3.906s-3.355-.458-4.092-1.862z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 20.5h13V14a6.5 6.5 0 1 0-13 0v6.5zm-3-17h19v2h-19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 5.5h17v15h-17z"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgFireplace);
var _default = exports["default"] = Memo;